export default __webpack_public_path__ + "static/media/protainer.f64a20f4.PNG";